import * as React from 'react';
import { connect } from 'react-redux';
import ImageModal from '../General/ImageModal';
import { fetchSeller, editSeller, fetchIntegradores, putSeller } from '../../actions/sellersActions';
import { putEstadoSellerApi, createImageSellerUrl } from '../../api/axios';
import Cleave from 'cleave.js/react';
import { toast } from '../../utilities/appToast';
import { getIdEstadoFromNombre } from '../../utilities/Seller/EstadoSeller';
import PropTypes from 'prop-types';
import { selectSellerMerged } from '../../helper/sellerMergedSelector';

const getErroresApi = (error) => {
    const data = error?.response?.data;

    if (Array.isArray(data?.errores)) return data.errores.filter(Boolean);
    if (data?.errors && typeof data.errors === 'object') {
        return Object.values(data.errors).flat().filter(Boolean);
    }

    return [];
};

class DatosBasicos extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            didEdit: false,
            isUpdatingEstado: false,
            srcImg: "",
            showImg: false
        };
        this.razonSocialInputRef = React.createRef();
    };

    componentDidMount() {
        this.props.fetchIntegradores();
    }

    cuitSoloDigitos = (cuit) => String(cuit ?? '').replace(/\D/g, '');

    formatoCuitConGuiones = (cuit) => {
        const d = this.cuitSoloDigitos(cuit);
        if (d.length === 11) {
            return `${d.slice(0, 2)}-${d.slice(2, 10)}-${d.slice(10)}`;
        }
        return d;
    };

    copyCuitAlPortapapeles = async () => {
        const digits = this.cuitSoloDigitos(this.props.seller?.cuit);
        if (!digits.length) {
            toast.warn('No hay CUIT para copiar');
            return;
        }
        const text = this.formatoCuitConGuiones(this.props.seller.cuit);
        try {
            await navigator.clipboard.writeText(text);
            toast.success('CUIT copiado');
        } catch {
            toast.error('No se pudo copiar el CUIT');
        }
    };

    myChangeHandler = (event) => {
        this.setState({ didEdit: true });
        let seller = { ...this.props.seller };
        const { name, value } = event.target;

        if (name === "etiquetaSellerResumen") {
            const newValue = value.replaceAll(/[^A-Za-z0-9]/g, "");
            seller[name] = newValue;
        } else {
            seller[name] = value;
        }
        this.props.editSeller(seller);
    }

    changeIntegrator = (event) => {
        this.setState({ didEdit: true });

        const value = Number(event.target.value);

        const integradorSeleccionado = this.props.integradores.find(
            i => i.codigo === value
        );

        let seller = { ...this.props.seller };

        seller.integrador = {
            idIntegrador: integradorSeleccionado.codigo,
            descripcion: integradorSeleccionado.descripcion
        };

        this.props.editSeller(seller);
    }

    clearImgInput = () => {
        let inputImg = document.getElementById("imgInput");
        inputImg.value = null;
    }

    showImgModal = (e, src) => {
        e.preventDefault();
        this.setState({ showImg: true, srcImg: src });
    }

    hideImgModal = () => {
        this.setState({ showImg: false });
    }

    addImg = async (e) => {
        const image = e.target.files[0];
        let req = createImageSellerUrl(image);
        req.then(res => {
            if (res != "Archivo incorrecto") {
                let seller = { ...this.props.seller, logo: res.url };
                this.props.editSeller(seller);
                this.clearImgInput();
            } else {
                toast.error(res)
            }
        }).catch(error =>
            toast.error("No se pudo cargar la imagen")
        );
    }

    updateEstadoSeller = (estado) => {
        const idUsuario = Number.parseInt(this.props.userId, 10) || 0;
        let params = {
            idUsuario,
            listRequest: [
                {
                    idSeller: this.props.seller.codigo,
                    idEstado: getIdEstadoFromNombre(estado)
                }
            ]
        };

        let sellers = putEstadoSellerApi(params);

        sellers.then(res => {
            toast.success("Estado de seller modificado");
        }).catch(err => {
            (err.response?.data?.errores)
                ? err.response.data.errores.forEach(error => toast.error(error))
                : toast.error("El estado no pudo modificarse");
        }).finally(() => {
            this.setState({ isUpdatingEstado: false });
        });
    };

    handleCheckboxChange = (field) => {
        const seller = { ...this.props.seller };

        if (field === 'emisionFacturaA') {
            const idSituacionIva = Number(seller.idSituacionIva ?? seller.IdSituacionIva);

            if (idSituacionIva !== 4) {
                toast.error("El seller no genera Factura A");
                return;
            }
        }

        if (field === 'estado') {
            this.setState({ isUpdatingEstado: true });
            seller.estado = seller.estado === "activo" ? "inactivo" : "activo";
            this.props.editSeller(seller);
            this.updateEstadoSeller(seller.estado);
        } else {
            seller[field] = !seller[field];
            this.props.editSeller(seller);

            if (['internacional', 'emisionFacturaA', 'tiendaActiva'].includes(field)) {
                let label = "";
                switch (field) {
                    case 'internacional': label = "Internacional"; break;
                    case 'emisionFacturaA': label = "Factura A"; break;
                    case 'tiendaActiva': label = "Tienda"; break;
                    default: label = field;
                }
                const status = seller[field] ? "activo" : "inactivo";

                putSeller({ ...seller, idUsuario: Number.parseInt(this.props.userId, 10) || 0 })
                    .then(res => toast.success(`${label} ${status}`))
                    .catch(err => {
                        const errores = getErroresApi(err);
                        if (errores.length > 0) {
                            errores.forEach(error => toast.error(error));
                        } else {
                            toast.error(`Error al actualizar ${label}`);
                        }
                        seller[field] = !seller[field];
                        this.props.editSeller(seller);
                    });
            }
        }
    }

    renderCustomSwitch = (label, field, forcedValue) => {
        const { seller } = this.props;
        const isActive = typeof forcedValue === 'boolean' ? forcedValue : seller[field];

        return (
            <button
                type="button"
                key={field}
                className={`profile-switch${isActive ? ' is-on' : ''}`}
                onClick={(e) => {
                    e.preventDefault();
                    this.handleCheckboxChange(field);
                }}
            >
                <span className="profile-switch__row">
                    <span className="profile-switch__track" aria-hidden="true">
                        <span className="profile-switch__knob" />
                    </span>
                    {label}
                </span>
                <span className="profile-switch__state">{isActive ? 'Activo' : 'Inactivo'}</span>
            </button>
        );
    }

    render() {
        let { seller } = this.props;
        let { showImg, srcImg } = this.state;
        const hasSellerId = seller.codigo !== undefined && seller.codigo !== null && seller.codigo !== "";
        const canEditFacturaA = Number(seller.idSituacionIva ?? seller.IdSituacionIva) === 4;

        let integradores = null;
        if (this.props.integradores != undefined) {
            integradores = this.props.integradores.map((item) => {
                return (
                    <option key={item.codigo} value={item.codigo}>{item.descripcion}</option>
                )
            })
        }

        return (
            <div className="tab-pane active" name="datos" id="home2" role="tabpanel">
                <section className="profile-section">
                    <header className="profile-section__head">
                        <span className="profile-section__icon" aria-hidden="true"><i className="ti-id-badge" /></span>
                        <div>
                            <h5 className="profile-section__title">Datos de la tienda</h5>
                            <p className="profile-section__hint">Identidad comercial, CUIT y canal de contacto.</p>
                        </div>
                    </header>
                    <div className="row g-3">
                        <div className="form-group col-md-6">
                            <label htmlFor="razonSocialDatosBasicos">Razón social</label>
                            <input
                                id="razonSocialDatosBasicos"
                                type="text"
                                className="form-control"
                                value={seller.razonSocial || ""}
                                onChange={this.myChangeHandler}
                                placeholder=""
                                name="razonSocial"
                                maxLength="100"
                                ref={this.razonSocialInputRef}
                            />
                        </div>

                        <div className="form-group col-md-6">
                            <label htmlFor="nombreTiendaDatosBasicos">Nombre tienda</label>
                            <input
                                id="nombreTiendaDatosBasicos"
                                type="text"
                                className="form-control"
                                value={seller.nombreTienda ?? ""}
                                onChange={this.myChangeHandler}
                                placeholder=""
                                name="nombreTienda"
                                maxLength="50"
                            />
                        </div>

                        <div className="form-group col-md-6">
                            <label htmlFor="emailDatosBasicos">e-Mail contacto comercial</label>
                            <input
                                id="emailDatosBasicos"
                                type="text"
                                className="form-control"
                                value={seller.email || ""}
                                onChange={this.myChangeHandler}
                                placeholder="usuario@dominio.com"
                                name="email"
                                maxLength="60"
                            />
                        </div>

                        <div className="form-group col-md-6">
                            <label htmlFor="cuitDatosBasicos">Cuit</label>
                            <div className="input-group">
                                <Cleave
                                    id="cuitDatosBasicos"
                                    className={hasSellerId ? 'form-control bg-light' : 'form-control'}
                                    name="cuit"
                                    value={seller.cuit || ""}
                                    options={{ blocks: [2, 8, 1], delimiter: '-', numericOnly: true }}
                                    onChange={hasSellerId ? undefined : this.myChangeHandler}
                                    readOnly={hasSellerId}
                                />
                                <button
                                    type="button"
                                    className="btn btn-outline-secondary"
                                    title="Copiar CUIT"
                                    onClick={this.copyCuitAlPortapapeles}
                                    disabled={!this.cuitSoloDigitos(seller.cuit).length}
                                >
                                    <i className="fa fa-copy" aria-hidden="true" />
                                </button>
                            </div>
                        </div>

                        <div className="form-group col-md-6">
                            <label htmlFor="integradorDatosBasicos">Integrador</label>
                            <select
                                id="integradorDatosBasicos"
                                name="integrador"
                                className="form-control"
                                value={seller.integrador?.idIntegrador ?? 1}
                                onChange={this.changeIntegrator}
                            >
                                {integradores}
                            </select>
                        </div>

                        <div className="form-group col-md-6">
                            <label htmlFor="resumenTarjetaSellerDatosBasicos">Resumen Tarjeta Seller</label>
                            <input
                                id="resumenTarjetaSellerDatosBasicos"
                                type="text"
                                className="form-control"
                                value={seller.etiquetaSellerResumen ?? ""}
                                onChange={this.myChangeHandler}
                                name="etiquetaSellerResumen"
                                maxLength="8"
                                placeholder="Ej: Ab9Cd8E1 (máx. 8 caracteres)"
                            />
                        </div>
                    </div>
                </section>

                {hasSellerId && (
                    <section className="profile-section">
                        <header className="profile-section__head">
                            <span className="profile-section__icon" aria-hidden="true"><i className="ti-settings" /></span>
                            <div>
                                <h5 className="profile-section__title">Configuración</h5>
                                <p className="profile-section__hint">Estado comercial de la tienda. Se guarda al activar cada opción.</p>
                            </div>
                        </header>
                        <div id="configuracionDatosBasicos" className="profile-switches">
                            {this.renderCustomSwitch("Internacional", "internacional")}
                            {this.renderCustomSwitch("Factura A", "emisionFacturaA", canEditFacturaA ? seller.emisionFacturaA : false)}
                            {this.renderCustomSwitch("Tienda Activa", "tiendaActiva")}
                        </div>
                    </section>
                )}

                <section className="profile-section">
                    <header className="profile-section__head">
                        <span className="profile-section__icon" aria-hidden="true"><i className="ti-image" /></span>
                        <div>
                            <h5 className="profile-section__title">Logo</h5>
                            <p className="profile-section__hint">PNG o JPG. Tocá la vista previa para ampliarla.</p>
                        </div>
                    </header>
                    <div className="profile-logo">
                        <label className="profile-logo__drop" htmlFor="imgInput">
                            <strong>Subir logo</strong>
                            <span>PNG o JPG</span>
                            <input
                                id="imgInput"
                                className="profile-logo__input"
                                type="file"
                                name="imagen"
                                onChange={this.addImg}
                                accept="image/png, image/jpeg"
                            />
                        </label>
                        {seller.logo ? (
                            <button type="button" className="profile-logo__preview" onClick={e => this.showImgModal(e, seller.logo)}>
                                <img
                                    alt="Imágen logo ingresada por el usuario"
                                    src={seller.logo}
                                    className="profile-logo__img"
                                />
                            </button>
                        ) : (
                            <div className="profile-logo__empty">Sin logo</div>
                        )}
                    </div>
                    <ImageModal
                        src={srcImg}
                        show={showImg}
                        onHide={this.hideImgModal}
                    />
                </section>
            </div>
        );
    }
}
DatosBasicos.propTypes = {
    // Redux props
    seller: PropTypes.shape({
        codigo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        razonSocial: PropTypes.string,
        email: PropTypes.string,
        cuit: PropTypes.string,
        integrador: PropTypes.oneOfType([PropTypes.shape({
            codigo: PropTypes.number,
        }), PropTypes.number]),
        nombreTienda: PropTypes.string,
        logo: PropTypes.string,
        etiquetaSellerResumen: PropTypes.string,
        idSituacionIva: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        IdSituacionIva: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    }),
    integradores: PropTypes.arrayOf(PropTypes.shape({
        codigo: PropTypes.number,
    })),
    // Actions props
    fetchIntegradores: PropTypes.func,
    editSeller: PropTypes.func,
}

const mapStateToProps = state => ({
    userType: state.general.userType,
    userId: state.general.userId,
    integradores: state.sellers.integradores,
    seller: selectSellerMerged(state),
});

export default connect(mapStateToProps, {
    fetchIntegradores,
    fetchSeller,
    editSeller
})(DatosBasicos);